import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { insights } from '../data/Insights';
// Import the translations & create an array of codes, note need to add i18next to below as well.
import surveyEn from '../translations/en-gb/survey.json';
import surveyCy from '../translations/cy/survey.json';
import surveyAldi from '../translations/en-aldi/survey.json';
import surveyMcdonalds from '../translations/en-mcdonalds/survey.json';
const langs = [
	'en-gb',
	'cy',
	'aldi',
	'mcdonalds',
];

// Set the language as 'en-gb' by default.
let theLang = 'en-gb';
// If defined in the index.html as window.insights then load from there
if (window.insights) {
	theLang = window.insights.lang;
} else if (insights) {
	theLang = insights.lang;
}

// Check if the lang is actually set & is in the array, if not go for en-gb
if (theLang === '' || !langs.includes(theLang)) {
	theLang = 'en-gb';
}

// Set the i18n object
i18n
	.use(initReactI18next)
	.init({
		interpolation: { escapeValue: false },
		lng: theLang,
		resources: {
			aldi: {
				survey: surveyAldi,
			},
			mcdonalds: {
				survey: surveyMcdonalds,
			},
			en: {
				survey: surveyEn,
			},
			cy: {
				survey: surveyCy,
			},
		},
	});

// Set the html attrs
// Grab the direction from the json file, a little convoluted as the useTranslation isn't available here.
document.documentElement.lang = i18n.options.resources[i18n.resolvedLanguage].survey.survey.attributes.langcode;
document.documentElement.dir = i18n.options.resources[i18n.resolvedLanguage].survey.survey.attributes.direction;

export default i18n;
